<style lang='stylus'scoped>
active = #336db0;

header {
  margin-bottom: 40px;
}

.title {
  font-size: 18px;
  color: #999999;
  position: relative;
  margin-right: 40px;
  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: active;

  &::after {
    background: @color;
  }
}
.header-t{
  font-size :18px;
  margin-bottom :35px;
}
</style>

<template>
  <header>
    <div class="header-t">各省内运营车辆分品牌加油站停靠占比统计</div>
    <span
      v-for="(item,index) in titleArr"
      :key="index"
      :class="{'title':true,'active':tab === index}"
      @click="changeTab(index,item)"
    >{{item}}</span>
  </header>
</template>
<script>
export default {
  props: {
    titleArr: {
      type: Array,
      default: []
    },
    changeTab: {
      type: Function,
      default: () => {}
    },
    tab: {
      type: Number,
      default: 0
    }
  }
}
</script>